
// NOTE: browser will handle the final part of localisation, e.g. month names etc.
// See details: http://www.ecma-international.org/ecma-402/2.0/#sec-intl-datetimeformat-constructor
export default {

	'en': {
		short: {
			year: 'numeric',
			month: 'short',
			day: 'numeric'
		},
		long: {
			year: 'numeric',
			month: 'short',
			day: 'numeric',
			weekday: 'short',
			hour: 'numeric',
			minute: 'numeric'
		}
	}

};



// WEBPACK FOOTER //
// ./src/locales/date-time-formats.js